import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { CacheService } from '../../services/cache/cache.service';
import { Comment, CommentsResult } from '../interfaces';

@Injectable({
  providedIn: 'root'
})
export class CommentsDataService {

  private uri: string = `${environment.apiUrl}comments`;
  private cacheKey: string = 'comments.cache';

  constructor(
    private http: HttpClient,
    private cache: CacheService,
  ) {

  }

  getComment(id: number): Observable<Comment|any> {
    return this.http.get(this.uri + `/${id}`);
  }

  getComments(parameters: {[param: string]: string | string[]}): Observable<CommentsResult|any> {
    return this.http.get(this.uri, {params: parameters});
  }

  addComment(data: Comment): Observable<Comment|any> {
    this.clearCache();
    const cleanData = Object.assign({}, data);
    delete cleanData.id;
    return this.http.post(this.uri, cleanData);
  }

  addComments(data: Comment[]): Observable<Comment[]|any> {
    this.clearCache();
    return this.http.post(this.uri + `/bulk`, data);
  }

  updateComment(data: Comment): Observable<Comment|any> {
    this.clearCache();
    const cleanData = Object.assign({}, data);
    delete cleanData.id;
    return this.http.put(this.uri + `/${data.id}`, cleanData);
  }

  updateComments(data: Comment[]): Observable<Comment[]|any> {
    this.clearCache();
    return this.http.put(this.uri + `/bulk`, data);
  }

  patchComment(data: Comment): Observable<Comment|any> {
    this.clearCache();
    const cleanData = Object.assign({}, data);
    delete cleanData.id;
    return this.http.patch(this.uri + `/${data.id}`, cleanData);
  }

  patchComments(data: Comment[]): Observable<Comment[]|any> {
    this.clearCache();
    return this.http.patch(this.uri + `/bulk`, data);
  }

  deleteComment(data: Comment): Observable<null|any> {
    this.clearCache();
    return this.http.delete(this.uri + `/${data.id}`);
  }

  deleteComments(data: Comment[]): Observable<null|any> {
    this.clearCache();
    const params: {ids: string} = {ids: ''};
    const ids: string[] = [];
    data.forEach((comment) => {
      ids.push(comment.id + '');
    });
    params.ids = ids.join(',');
    return this.http.delete(this.uri + `/bulk`, {params: params});
  }

  clearCache(): void {
    this.cache.remove(this.cacheKey);
  }

}
